var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "_indexPage"
  }, [_vm.theme == 'tapcoin' ? [_vm.web3Config.hasOwnProperty('version') && _vm.web3Config.version > 1 ? _c('tapcoin-index-new') : _c('tapcoin-index')] : _vm.theme == 'goldcoin' ? _c('goldcoin-index') : _vm.theme == 'reflection' ? _c('reflection-index') : _vm.theme == 'memetown' ? _c('memetown-index') : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };